export enum FieldGroup {
  AudienceDetails = 'audienceDetails',
  ItemInfo = 'itemInfo',
  ContentInfo = 'contentInfo',
  AdditionalItemDetails = 'additionalItemDetails'
}
